import { ActionType, createAction } from 'typesafe-actions'

import { Dictionary } from '../../../utils/types'

import { Invoice, InvoiceInfo } from './types'

export const InvoiceActions = {
  fetchData: createAction('INVOICES/load-data')<{
    page: number
    pageSize: number
    filter: string
  }>(),
  setData: createAction('INVOICES/set-data')<{
    page: number
    totalPages: number
    data: Invoice[]
  }>(),
  setFilter: createAction('INVOICES/set-filter')<string>(),
  setFilters: createAction('INVOICES/set-filters')<Dictionary<any>>(),
  clearFilter: createAction('INVOICES/clear-filters')<{ filterKey: string }>(),
  setInvoiceDetails: createAction('INVOICES/set-invoice')<{
    invoiceId: string
    invoiceData: InvoiceInfo
  }>(),
  loadInvoiceDetails: createAction('INVOICES/load-invoice')<{ invoiceId: string }>(),
  downloadInvoice: createAction('INVOICES/download-invoice')<{
    invoiceId: string
    downloadInvoiceName: string
  }>()
}

export type InvoiceActions = ActionType<typeof InvoiceActions>
